import { render, staticRenderFns } from "./InventoryGrid.vue?vue&type=template&id=38387171"
import script from "./InventoryGrid.vue?vue&type=script&lang=js"
export * from "./InventoryGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports